import React from "react";

import "./editModal.css";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import EditIcon from "../../../assets/icon/Edit.svg";

import CloseIcon from "@mui/icons-material/Close";
import { userProfileUpdate } from "../../../services/MainApiDetails";
import { ERROR } from "../../../utilities/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditNameModal = (prop) => {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (!!prop.name) setName(prop.name);
    if(open) setError("")
  }, [prop.name, open]);

  const buttonDisabled = React.useMemo(
    () => prop.name?.trim() === name?.trim(),
    [prop.name, name],
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  function updateName() {
    if (!name) {
      setError("Please Enter name");
    } else {
      userProfileUpdate({
        name: name?.trim(),
      })
        .then((res) => {
          if (res.data.status) {
            alert("Name updated successfully");
            setOpen(false);
            window.location.reload();
          } else {
            alert(res.data.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  return (
    <div className="editNameModal">
      <div onClick={handleClickOpen} className="userInfo-edit">
        <img src={EditIcon} alt="" />
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="editNameModal-wrapper">
          <div className="editNameModal-closeIcon">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="editNameModal-header">
            <h2>Edit Your Name</h2>
          </div>
          <div className="editNameModal-form-wrapper">
            <form action="">
              <div className="editNameModal-input-wrapper">
                <div className="editNameModal-inputBox">
                  <span>Enter new name</span>
                  <input
                    type="text"
                    placeholder="Type here"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <span style={{ color: ERROR }}>{error}</span>
                </div>
              </div>
            </form>
          </div>
          <div className="editNameModal-button-wrapper">
            <Button
              type="button"
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? "editNameModal-login-btn-disabled"
                  : "editNameModal-login-btn"
              }
              onClick={updateName}
            >
              UPDATE
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EditNameModal;
